export const filterSystemAndCurrentUser = function (users, currentProfile) {
  if (!users || !currentProfile) return [];

  return users.filter(
    user =>
      !user.isSystemUser &&
      !(
        user.externalId === currentProfile.externalId &&
        user.externalScope === currentProfile.externalScope
      )
  );
};

export const convertToUser = function (record, store) {
  let { externalId, externalScope, name, organizationId } = record;
  let existingRecord = store
    .peekAll('messaging-user')
    .find(
      user => user.externalId === record.externalId && user.externalScope === record.externalScope
    );
  return (
    existingRecord ||
    store.createRecord('messaging-user', {
      externalId,
      externalScope,
      name,
      organizationId,
    })
  );
};

export const matchingUsers = function (userA, userB) {
  return userA.externalId === userB.externalId && userA.externalScope === userB.externalScope;
};
